export default __webpack_public_path__ + "static/media/3.4aa36bd8.jpg";